import { useTranslation } from 'react-i18next';
import { memo, useEffect, useState } from 'react';
import { useAtom, useAtomValue } from 'jotai';
import { styled } from 'styled-components';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { remote_mapData_getByProject } from '~/common/typescript/apis/MapDataAPIs';
import { mapDataListAtom, showLegendPanelAtom, mapDataListRefreshTrigger } from '~/components/Map/stores/mapStore';
import MapDataUtils from '~/components/Map/utils/MapDataUtils';
import { currentProjectAtom } from "~/stores/ProjectStore";
import LayerItem from './LayerItem';
import { Empty } from 'antd';

const LegendTab = () => {
  const [mapDataLayers, setMapDataLayers] = useAtom(mapDataListAtom);
  const [currentProject, setCurrentProject] = useAtom(currentProjectAtom);
  const refreshTrigger = useAtomValue(mapDataListRefreshTrigger);

  const fetchMapData = async () => {
    if (!currentProject || !currentProject.id || !localStorage.jwt) {
      return;
    }

    try {
      const res = await remote_mapData_getByProject(currentProject.id);
      setMapDataLayers((prev) => {
        const freshList = (res || []).filter(Boolean);
        return freshList.map((newLayer: any) => {
          const existingLayer = prev.find((layer) => layer?.id === newLayer?.id);
          return {
            ...newLayer,
            visible: existingLayer?.visible ?? false,
          };
        });
      });
    } catch (error) {
      console.error('remote_getListMapData', error);
    }
  };

  useEffect(() => {
    fetchMapData();
  }, [localStorage.jwt, currentProject?.id, refreshTrigger]);

  const onDragEnd = (result: any) => {
    console.log('result', result);

    if (!result.destination) {
      return;
    }

    const items = Array.from(mapDataLayers);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    // Lấy layer đang hiển thị nằm trên nó gần nhất
    const layerAbove = items.slice(0, result.destination.index).reverse().find(layer => layer.visible);
    if (layerAbove) {
      MapDataUtils.moveToBelowOf(reorderedItem, layerAbove.id);
    } else {
      MapDataUtils.moveToTop(reorderedItem);
    }

    setMapDataLayers(items);
  };


  return <>
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="layers">
        {(provided) => (
          <div
            {...provided.droppableProps}
            ref={provided.innerRef}
          >
            {
              mapDataLayers.length === 0 && (
                <div style={{ textAlign: 'center', padding: 20, color: '#666' }}>
                  <Empty />
                </div>
              )
            }
            {mapDataLayers.map((layer, index) => (
              <Draggable
                key={layer.id}
                draggableId={layer.id.toString()}
                index={index}
              >
                {(provided) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                  >
                    <LayerItem
                      data={layer}
                      onDelete={() => {
                        MapDataUtils.removeFromMap(layer);
                        setMapDataLayers((prev) => prev.filter((item) => item?.id !== layer.id));
                      }}
                      toggleVisibility={(visible) => {
                        setMapDataLayers((prev) =>
                          prev.map((item, i) =>
                            i === index ? { ...item, visible } : item
                          )
                        );
                        if (visible) {
                          // Lấy layer đang hiển thị nằm dưới nó gần nhất
                          let layerAbove = null;
                          for (let i = index - 1; i >= 0; i--) {
                            if (mapDataLayers[i].visible) {
                              layerAbove = mapDataLayers[i];
                              break;
                            }
                          }
                          MapDataUtils.addToMap(layer, layerAbove?.id || undefined);
                        } else {
                          MapDataUtils.removeFromMap(layer);
                        }
                      }}
                    />
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext></>
}

export default memo(LegendTab);